import type * as React from 'react';

import PriorityHigh from '@/components/PriorityList/icons/high.svg?react';
import PriorityLow from '@/components/PriorityList/icons/low.svg?react';
import PriorityMedium from '@/components/PriorityList/icons/medium.svg?react';
import { IconWrapper } from '@/features/ManageContacts/common';

type PriorityIconType = {
  priority?: string;
};

export const PriorityIcon = ({
  priority,
  ...rest
}: Omit<React.HTMLAttributes<HTMLSpanElement>, 'css'> & PriorityIconType) => {
  return (
    <IconWrapper {...rest}>
      {priority === 'HIGH' ? (
        <PriorityHigh />
      ) : priority === 'MEDIUM' ? (
        <PriorityMedium />
      ) : (
        <PriorityLow />
      )}
    </IconWrapper>
  );
};
